import { Directive, ViewContainerRef, OnInit } from '@angular/core';

@Directive({
  selector: '[dynamic-tabs]'
})
export class DynamicTabsDirective implements OnInit {
  constructor(public viewContainer: ViewContainerRef) {}

  ngOnInit(): void {
   // console.log (' inicializando DynamicTabsDirective ');
  }
}
